// libs/core/shell/src/lib/theme/theme-applier.service.ts
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, AppConfig } from '@cardapio-online/config';
import { SystemConfigService } from '../system/system-config.service';
import type { ShellThemeMode } from '../system/system-config.interface';
import { BrandKernelService } from '@cardapio-online/theme';

@Injectable({ providedIn: 'root' })
export class ThemeApplierService {
  readonly storageKey = this.systemConfigService.storageKey;

  constructor(
    @Inject(APP_CONFIG) private readonly cfg: AppConfig,
    private readonly systemConfigService: SystemConfigService,
    private readonly brandKernel: BrandKernelService
  ) {}
apply(root: HTMLElement = document.documentElement): void {
  const liveBrand = this.brandKernel.config();
  const brandPrimary = liveBrand.brandPrimary || this.cfg.brandPrimary;

  root.style.setProperty('--brand-primary', brandPrimary);
  root.style.setProperty('--shell-brand', brandPrimary);
  root.style.setProperty('--accent', brandPrimary);
  root.style.setProperty('--ds-color-primary', brandPrimary);

  const brandSecondary =
    'brandSecondary' in liveBrand
      ? String((liveBrand as { brandSecondary?: string }).brandSecondary ?? '')
      : '';

  if (brandSecondary) {
    root.style.setProperty('--brand-secondary', brandSecondary);
    root.style.setProperty('--shell-brand-2', brandSecondary);
    root.style.setProperty('--accent-2', brandSecondary);
  }

  const saved = this.systemConfigService.snapshot().themeMode;
  this.applyTheme(saved, root);
}

  toggle(root: HTMLElement = document.documentElement): ShellThemeMode {
    const current =
      (root.getAttribute('data-theme') as ShellThemeMode | null) ?? 'dark';

    const next: ShellThemeMode = current === 'dark' ? 'light' : 'dark';
    this.set(next, root);
    return next;
  }

  set(theme: ShellThemeMode, root: HTMLElement = document.documentElement): void {
    this.applyTheme(theme, root);
    this.systemConfigService.update({ themeMode: theme });
  }

  getCurrent(root: HTMLElement = document.documentElement): ShellThemeMode {
    return (
      (root.getAttribute('data-theme') as ShellThemeMode | null) ??
      this.systemConfigService.snapshot().themeMode
    );
  }

  private applyTheme(
    theme: ShellThemeMode,
    root: HTMLElement = document.documentElement
  ): void {
    root.setAttribute('data-theme', theme);
  }
}
